import type { FC, ReactElement } from 'react';
import styles from '../styles/bullet-list.module.scss';

const BulletList: FC<{
    children: ReactElement<HTMLLIElement> | ReactElement<HTMLLIElement>[];
}> = ({ children }) => {
    return <ul className={styles.bulletList}>{children}</ul>;
};

export default BulletList;
